export default __webpack_public_path__ + "static/media/Screenshot2.7a4996b3.png";